import { observer } from "mobx-react-lite";

import { usePlaceholderContainer } from "@/components/Playground/Messages/PlaceholderContainer/context/placeholder-container-context";
import { CarouselSlideControls } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";

export const PCCarouselIndicator = observer(() => {
  const { placeholderStore, variableSets } = usePlaceholderContainer();
  const { activeSetId } = placeholderStore;

  const currentIndex = variableSets.findIndex(s => s.id === activeSetId);
  const currentSet = variableSets[currentIndex];

  if (variableSets.length <= 1) {
    return null;
  }

  const displayName = currentSet?.name || "";

  return (
    <div
      className={cn(
        "flex items-center justify-between",
        "border-b border-dashed border-gray-200",
        "px-3.5 py-1.5",
        "select-none",
      )}
    >
      <span className="truncate text-xs font-medium text-gray-500">{displayName}</span>

      <div className="flex items-center gap-x-2">
        <CarouselSlideControls showArrows={false} />
        <span className="whitespace-nowrap text-[11px] tabular-nums text-gray-400">
          {currentIndex + 1}/{variableSets.length}
        </span>
      </div>
    </div>
  );
});
